<div class="form-group row date {{class}}">
   <label *ngIf="labelCaption" for="{{id}}" class="{{labelClass}}" [ngClass]="{'col-form-label': !labelStacked, 'col-form-label-sm': sm}">{{labelCaption}}
      <span *ngIf="required" class="asterix">*</span>
      <span *ngIf="!editable">:</span>
   </label>
   <div *ngIf="!editable" class="input-container data-value {{inputClass}}">
      <label class="col-form-label">{{getDataValue()}}</label>
   </div>
   <div *ngIf="editable" class="controls">
      <div class="input-group">
         <input type="text" class="form-control" id="{{id}}" autocomplete="off"
           [placement]="placement"
           ngbDatepicker #d="ngbDatepicker"
           container="body"
           [formControl]="ngControl.control"
           [minDate]="mindate"
           [maxDate]="maxdate"
           [weekdays]="true"
           [attr.maxlength]="10"
           [ngClass]="{'is-invalid': editable && ngControl.invalid && (ngControl.touched || submitted), 'form-control-sm': sm }"
           (blur)="blur($event)">
         <div class="input-group-append">
            <button type="button" tabindex="-1" class="input-group-text btn btn-sm btn-light calendar" (click)="d.toggle()">
               <i class="far fa-calendar-check"></i>
            </button>
         </div>
      </div>
      <ng-content></ng-content>
   </div>
</div>
